module.exports = __webpack_public_path__ + "static/media/M24ws.9f7cd184.pdf";